import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { isInterestFieldDefined } from '../../utils/interestUtils';
import UsageTracker from '../../utils/UsageTracker';
import { isLessonRecommendation, usePostRecommendationsFeedback, useRecommendations, useRecommendationsTopicPreference } from '../../features/recommendations';
import { RouterLink } from '../AcademyLinks';
import { useLearningContentCardModels } from 'academy-common-lib/features/cards/hooks/useLearningContentCardModels';
import getLang from 'academy-common-lib/utils/getLang';
import Raven from 'raven-js';
import { CardsSection } from '../../features/cardsSection/components/CardsSection';
import { jsx as _jsx } from "react/jsx-runtime";
const TopicBasedReason = ({
  topic,
  source
}) => {
  const hasTopic = isInterestFieldDefined(topic);
  const setLearningInterestLink = () => {
    UsageTracker.track('interaction', {
      action: 'field-recommendation-set-learning-interest-clicked'
    });
  };
  return /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: `learningCenter.tracks.subheaders.${hasTopic ? source === 'JOB_FIELD' ? 'becauseJobField' : 'becauseInterest' : 'becauseNotSet'}`,
    options: {
      roleName: /*#__PURE__*/_jsx(FormattedMessage, {
        "data-test-id": "topic-preference-label",
        message: `learningCenter.learningTopics.options.${topic}`
      }),
      setFieldLink: /*#__PURE__*/_jsx(RouterLink, {
        "data-test-id": "preference-change-button",
        onClick: setLearningInterestLink,
        to: "/wizard",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `learningCenter.fieldLink.set`
        })
      })
    }
  });
};
const SubTitle = ({
  metadata,
  savedTopicPreference
}) => {
  if (savedTopicPreference) {
    const {
      topic,
      source
    } = savedTopicPreference;
    return /*#__PURE__*/_jsx(TopicBasedReason, {
      source: source,
      topic: topic
    });
  }
  const {
    preferredTopic,
    source
  } = metadata || {};
  if (preferredTopic) {
    return /*#__PURE__*/_jsx(TopicBasedReason, {
      source: source,
      topic: preferredTopic
    });
  }
  return null;
};
const useRecommendationsBasedOnField = () => {
  const {
    recommendations: recommendationsResponse,
    recommendationsLoading,
    recommendationsError
  } = useRecommendations();
  const {
    recommendations,
    correlationId
  } = recommendationsResponse || {};

  // retrieves hydrated card models for the elements to render
  const {
    cardModels,
    cardModelsError,
    cardModelsLoading
  } = useLearningContentCardModels({
    items: (recommendations === null || recommendations === void 0 ? void 0 : recommendations.map(({
      recommendationId,
      recommendationType,
      recommendationMetadata,
      recommendationStrategy
    }) => {
      return {
        id: recommendationId,
        type: recommendationType,
        language: getLang(),
        metadata: recommendationMetadata,
        strategy: recommendationStrategy
      };
    })) || [],
    skip: !(recommendations !== null && recommendations !== void 0 && recommendations.length)
  });
  return {
    content: cardModels,
    loading: recommendationsLoading || cardModelsLoading,
    error: recommendationsError || cardModelsError,
    correlationId
  };
};
const RecommendationsBasedOnField = () => {
  var _content$;
  const {
    postRecommendationsFeedback
  } = usePostRecommendationsFeedback();
  const {
    recommendationsTopicPreference
  } = useRecommendationsTopicPreference();
  const {
    content,
    error,
    loading,
    correlationId
  } = useRecommendationsBasedOnField();
  if (!loading && !error && !(content !== null && content !== void 0 && content.length)) return null;
  const handleOnItemClick = ({
    id,
    type,
    language,
    name,
    strategy,
    metadata
  }, index) => {
    UsageTracker.track('interaction', {
      action: 'catalog-recommendation-card-click',
      cardNumber: index + 1,
      contentId: id,
      contentType: type,
      name,
      language: language,
      recommendationType: 'spark-based',
      recommendationStrategy: strategy,
      recommendedBecauseTrackId: (metadata === null || metadata === void 0 ? void 0 : metadata.entityType) === 'TRACK' && (metadata === null || metadata === void 0 ? void 0 : metadata.entityId),
      recommendedBecauseLessonId: (metadata === null || metadata === void 0 ? void 0 : metadata.entityType) && isLessonRecommendation(metadata === null || metadata === void 0 ? void 0 : metadata.entityType) && (metadata === null || metadata === void 0 ? void 0 : metadata.entityId)
    });
    if (correlationId) {
      postRecommendationsFeedback({
        correlationId,
        entityType: type,
        entityId: id
      }).catch(Raven.captureException.bind(Raven));
    }
  };
  return /*#__PURE__*/_jsx(CardsSection, {
    appearsIn: "recommendations-field",
    content: content,
    description: /*#__PURE__*/_jsx(SubTitle, {
      metadata: content === null || content === void 0 || (_content$ = content[0]) === null || _content$ === void 0 ? void 0 : _content$.metadata,
      savedTopicPreference: recommendationsTopicPreference
    }),
    displayFullCardsOnMobile: false,
    error: error,
    header: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.tracks.headers.recommended"
    }),
    isLoading: loading,
    navMarker: !loading && !error ? 'HOMEPAGE_RECOMMENDATIONS_LOADED' : undefined,
    onItemClick: handleOnItemClick,
    size: "extra-large"
  });
};
export default RecommendationsBasedOnField;